import {
  ReanalysisDocument,
  withStandardPrefetchHook,
} from '@spotify/confidence-graphql';

export const useReanalysisPrefetch =
  withStandardPrefetchHook(ReanalysisDocument);
